export default {
  title: "Trend-Diagramm",
  recent_records: "Neueste Datensätze",
  preview_report: "Berichtsvorschau",
  compliant_status_good: "Compliance-Status gut",
  custom_factor_status: "Benutzerdefinierter Faktor wird verwendet, Compliance-Status ausstehend",
  tax_amount: "Steuerbetrag",
  based_on_eur: "Basierend auf €{amount}",
  total_emission: "Gesamtemission",
  recent_calculation_date: "Datum der letzten Berechnung",
  no_records: "Keine Datensätze",
  calculate_now: "Jetzt berechnen",
  cbam_news: "CBAM-Nachrichten",
  no_news: "Keine Nachrichten",
  usage_stats_and_price: "Nutzungsstatistik & Kohlenstoffpreis",
  monthly_calculation_count: "Monatliche Berechnungsanzahl",
  monthly_report_count: "Monatliche Berichtsanzahl",
  monthly_avg_emission: "Monatliche durchschnittliche Emission",
  today_carbon_price: "Heutiger Kohlenstoffpreis",
  current_plan: "Aktueller Plan: {plan}",
  upgrade_now: "Jetzt upgraden",
  trial_remaining: "{days} Tage verbleibend, {calculations} Berechnungen, {reports} Berichte",
  expiry_date: "Ablaufdatum: {date}",
  free_plan_desc1: "100 Berechnungen pro Monat, 1 Bericht pro Tag",
  free_plan_desc2: "Upgrade durchführen, um weitere Funktionen freizuschalten!",
  trial_expired: "Testphase abgelaufen, auf Pro-Plan upgraden (99 €/Monat), um fortzufahren",
  config_fetch_failed: "Konfiguration konnte nicht abgerufen werden",
};
